import { colors } from '@apollo/brand';
import { customColors } from '@apollo/orbit';
import { useMemo } from 'react';

import { useStackInfo } from 'src/components/charts/helpers/useStackInfo';
import { LineChartStackConfig } from 'src/components/charts/LineChart';
import { Timestamp } from 'src/lib/graphqlTypes/customScalarTypes';

import { LatencyPercentileChart } from '../../useCurrentField';

export interface FieldChartData {
  timestamp: Timestamp['output'];
  metrics: {
    fieldHistogram: {
      p50: number | null;
      p90: number | null;
      p95: number | null;
    };
  };
}

const labelByChartType = {
  p50: 'P50 Latency',
  p90: 'P90 Latency',
  p95: 'P95 Latency',
};

export const useFieldChartStackInfo = (
  data: FieldChartData[] | undefined,
  chartType: LatencyPercentileChart,
) => {
  const stacks = useMemo(
    (): LineChartStackConfig<FieldChartData>[] => [
      {
        data: data ?? [],
        colorGradientTop: `${colors.primitives.blue[300]}3C`,
        colorGradientBottom: `${colors.primitives.blue[300]}00`,
        primaryColor: customColors.flowchart.d,
        cursorColor: customColors.brand.accent,
        label: labelByChartType[chartType],
        hasData: ({ metrics }) => Boolean(metrics.fieldHistogram[chartType]),
        getValue: ({ metrics, timestamp }) => ({
          timestamp,
          value: Number(metrics.fieldHistogram[chartType]),
        }),
      },
    ],
    [data, chartType],
  );
  return useStackInfo<
    FieldChartData,
    { value: number },
    LineChartStackConfig<FieldChartData>
  >(stacks);
};
